export default __webpack_public_path__ + "static/images/android-app.20ec0982.png";